import React from 'react';
import { PriceString, ProfitString } from '@fourthwall/components';
import { SUMMARY_ROW_ID } from '@fourthwall/module-analytics';
import { TimezonedDateString } from '../../../../../../../../Timezone/components/TimezonedDateString';
import { getDateFormat } from './getDateFormat';
export const createChartStatsTableColumns = (params) => [
    {
        header: params.precision === 'HOUR' ? 'Time' : 'Day',
        render: (item) => {
            if (item.id === SUMMARY_ROW_ID)
                return item.day;
            return (React.createElement(TimezonedDateString, { date: item.day, format: getDateFormat(params.precision), withTimezoneAbbreviation: false }));
        },
    },
    { header: 'Transaction Value', render: (item) => React.createElement(PriceString, { value: item.value }) },
    { header: 'Cost', render: (item) => React.createElement(PriceString, { value: item.cost }) },
    { header: 'Contributions', render: (item) => item.contribution },
    { header: 'Profit', render: (item) => React.createElement(ProfitString, { value: item.profit }) },
];
